import { addElement } from '../utilities/_elements'

const forms = {
	config: {
		formField: '.hs-form-field, .form-field',
		hsSubmitButton: '.hs-submit .hs-button',
		hsGatedForm: '.hs-gated-form'
	},

	elements: {},

	init() {
		const self = this

		// Handle form fields
		//
		self.elements.formFields = document.querySelectorAll(self.config.formField)
		if (self.elements.formFields !== null) {
			for (let i = 0; i < self.elements.formFields.length; i++) {
				const formField = self.elements.formFields[i]

				if (
						formField.classList.contains('hs-fieldtype-text') ||
						formField.classList.contains('fieldtype-text') ||
						formField.classList.contains('hs-fieldtype-textarea') ||
						formField.classList.contains('fieldtype-textarea') ||
						formField.classList.contains('hs-fieldtype-date') ||
						formField.classList.contains('fieldtype-date')
					) {
					self.handleInput(formField)
				}
			}
		}

		// Handle submit button replacements (<button>)
		//
		self.elements.hsSubmitButtons = document.querySelectorAll(self.config.hsSubmitButton)
		if (self.elements.hsSubmitButtons !== null) {
			for (let i = 0; i < self.elements.hsSubmitButtons.length; i++) {
				const hsSubmitButton = self.elements.hsSubmitButtons[i]

				self.handleSubmitButton(hsSubmitButton)
			}
		}

		// Handle gated form
		//
		self.elements.hsGatedForm = document.querySelector(self.config.hsGatedForm)
		if (self.elements.hsGatedForm !== null) {
			self.handleGatedForm(self.elements.hsGatedForm)
		}
	},

	handleInput(formField) {
		const input = formField.querySelector("input, textarea")

		if (input.value !== '') {
			formField.classList.add('has--content')
		} else {
			formField.classList.remove('has--content')
		}

		input.addEventListener('change', function () {
			if (input.value !== '') {
				formField.classList.add('has--content')
			} else {
				formField.classList.remove('has--content')
			}
		})

		input.addEventListener('focus', function () {
			formField.classList.add('has--focus')
		})

		input.addEventListener('blur', function () {
			formField.classList.remove('has--focus')

			if (input.value !== '') {
				formField.classList.add('has--content')
			} else {
				formField.classList.remove('has--content')
			}
		})
	},

	handleSubmitButton(hsSubmitButton) {
		const self = this

		const wrapper = hsSubmitButton.parentNode

		addElement({
			elementTag: 'button',
			classes: 'btn btn--red',
			setAttributes: {
				'type': 'submit'
			},
			innerHTML: hsSubmitButton.value,
			appendTo: wrapper
		})
	},

	handleGatedForm(hsGatedForm) {
		const self = this

		window.addEventListener("message", function(event) {
			if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
				hsGatedForm.classList.add('submitted')
			}
		})
	}
}

if (document.readyState === 'complete') {
	setTimeout(function() {
		forms.init()
	}, 250)
} else {
	window.addEventListener('load', () => {
		setTimeout(function() {
			forms.init()
		}, 250)
	})
}

window.addEventListener('formsUpdate', function() {
	forms.init()
})
